import { ColDef } from "ag-grid-community";
import { IntegrationsDefaultConversationCellRenderer } from "../../../common/components/grid/cell-renderers/IntegrationsDefaultConversationCellRenderer";
import { IntegrationsInUseCellRenderer } from "../../../common/components/grid/cell-renderers/in-use-cell/IntegrationsInUseCellRenderer";
import { IntegrationsCreatedByCellRenderer } from "../../../common/components/grid/cell-renderers/IntegrationsCreatedByCellRenderer";
import { IntegrationsActionCellRenderer } from "../../../common/components/grid/cell-renderers/action-cell/IntegrationsActionCellRenderer";
import { agGridEmptyColumnToFitEmptySpace } from "../../../../../../common/ag-grid/utils/constants/agGridEmptyColumnToFitEmptySpace";
import { IntegrationsNameCellRenderer } from "../../../common/components/grid/cell-renderers/IntegrationsNameCellRenderer";
import { integrationsInUseComparator } from "../../../common/components/grid/comparators/integrationsInUseComparator";
import { integrationsInUseValueGetter } from "../../../common/components/grid/value-getters/integrationsInUseValueGetter";
import { integrationsCreatedByQuickFilter } from "@/components/pages/integrations/components/communications/common/components/grid/quick-filters/integrationsCreatedByQuickFilter";
import { integrationsCreatedBySortingFn } from "@/components/pages/integrations/components/communications/common/components/grid/comparators/integrationsCreatedBySortingFn";
import { IntegrationsModifiedByCellRenderer } from "@/components/pages/integrations/components/communications/common/components/grid/cell-renderers/IntegrationsModifiedByCellRenderer";
import { integrationsModifiedByQuickFilter } from "@/components/pages/integrations/components/communications/common/components/grid/quick-filters/integrationsModifiedByQuickFilter";
import { integrationsModifiedBySortingFn } from "@/components/pages/integrations/components/communications/common/components/grid/comparators/integrationsModifiedBySortingFn";
import { agGridActionColumnDefaultColumnDef } from "@/components/pages/common/ag-grid/utils/constants/agGridActionColumnDefaultColumnDef";

export const slackIntegrationGridColumns: ColDef[] = [
  {
    field: "name",
    headerName: "Workspace",
    minWidth: 200,
    cellRenderer: IntegrationsNameCellRenderer,
  },
  {
    field: "metadata.conversation.name",
    headerName: "Default Conversations",
    minWidth: 240,
    cellRenderer: IntegrationsDefaultConversationCellRenderer,
  },
  {
    field: "usages",
    headerName: "In Use",
    minWidth: 300,
    cellRenderer: IntegrationsInUseCellRenderer,
    valueGetter: integrationsInUseValueGetter,
    comparator: integrationsInUseComparator,
  },
  {
    field: "created_by",
    headerName: "Created By",
    minWidth: 250,
    cellRenderer: IntegrationsCreatedByCellRenderer,
    getQuickFilterText: integrationsCreatedByQuickFilter,
    comparator: integrationsCreatedBySortingFn,
  },
  {
    field: "modified_by",
    headerName: "Last Modified By",
    minWidth: 250,
    cellRenderer: IntegrationsModifiedByCellRenderer,
    getQuickFilterText: integrationsModifiedByQuickFilter,
    comparator: integrationsModifiedBySortingFn,
  },
  agGridEmptyColumnToFitEmptySpace,
  {
    ...agGridActionColumnDefaultColumnDef,
    colId: "actions",
    width: 80,
    minWidth: 80,
    cellRenderer: IntegrationsActionCellRenderer,
  },
];
